import axios from "axios";
import { attachToastInterceptors } from "@/app/config/toastHelpers";

type CreateClientOptions = {
  baseURL?: string;
  withCredentials?: boolean;
};

function getLocale(): string {
  if (typeof document === "undefined") return "en";

  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("NEXT_LOCALE="))
    ?.split("=")[1];
  if (cookie) return cookie;

  const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  return match ? match[1] : "en";
}

export function createApiClient(options: CreateClientOptions = {}) {
  const { baseURL, withCredentials = false } = options;

  const client = attachToastInterceptors(
    axios.create({
      baseURL,
      timeout: 10000,
      withCredentials,
      headers: {
        "Content-Type": "application/json",
      },
    })
  );

  client.interceptors.request.use((config) => {
    config.headers["Accept-Language"] = getLocale();
    return config;
  });

  return client;
}
